import React, { useEffect } from 'react';
import { useUser } from '../../auth/UseUser';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as PuskicaLogoSarena } from '../../assets/svg/PuskicaLogoSarena.svg';

export const kvizList = [
    {
        naziv: 'Klasik',
        opis: 'Klasik kviz je tradicionalni format kviza koji se sastoji od niza pitanja sa ponuđenim odgovorima.',
        id: '1',
        path: '/user/kviz/klasik',
    },
    {
        naziv: 'Lovac - Vežbanje',
        opis: 'Lovac kviz je dinamičan format kviza koji kombinuje pitanja sa elementima igre, gde učesnici imaju ograničeno vreme da odgovore i treba da se popnu na vrh piramide',
        id: '2',
        path: '/user/kviz/lovac',
    },
    {
        naziv: 'Lovac - Takmičarski',
        opis: 'Takmičarska varijanta Lovac kviza - meri se vreme do vrha piramide, pitanja su sve teža kako se penješ, a najbrži rezultati ulaze u rang listu.',
        id: '3',
        path: '/user/kviz/lovac/takmicarski',
    },
];

function KvizHome() {
    const { tipEtiteta, setTipEtiteta, returnedList, setReturnedList, setNavLista } = useUser();
    useEffect(() => {
        setReturnedList(kvizList);
    }, []);
    return (
        <div className="flex-1 flex h-full flex-col items-center overflow-y-auto bg-blueDark py-[40px]">
            <div className=" w-full h-full max-w-[1100px] px-[10px]">
                <div className="w-full min-h-full  bg-blueMedium flex flex-col p-[30px] rounded-[10px]">
                    <p className=" text-gold font-semibold text-[22px] leading-7 text-center">Kvizovi</p>
                    <div className="mt-6 flex flex-col gap-3">
                        {kvizList.map((item: any, index: number) => {
                            return <KvizItem key={item.id} item={item} />;
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default KvizHome;

const KvizItem = ({ item }: any) => {
    const navigate = useNavigate();

    return (
        <>
            {/* Desktop version */}
            <p className="text-obrazovanje-primary hidden lg:flex items-center flex-wrap gap-1 ">
                <span
                    className="text-gold flex items-center whitespace-nowrap border-b border-blueSuperLight hover:border-gold cursor-pointer transition-all duration-200"
                    onClick={() => navigate(item.path)}
                    title={`Otvori kviz "${item.naziv}".`}
                >
                    <PuskicaLogoSarena width={40} height={40} className="mr-1" />
                    {item.naziv}:
                </span>
                {item.opis}
            </p>
            {/* Mobile version */}
            <button className="flex lg:hidden flex-row items-center gap-2 bg-blueDark  rounded-[10px] py-[6px] px-2" onClick={() => navigate(item.path)}>
                <PuskicaLogoSarena width={45} height={45} />
                <p className="text-obrazovanje-title flex-1 text-left">{item.naziv} </p>
            </button>
        </>
    );
};
